var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { matchPath } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { useRoute } from 'components/router/Routing';
import { React } from 'libs/react';
import './Link.scss';
/**
 * @component Link
 * @since 1.0.0
 */
export function Link(props) {
    let { route, match, exact, strict, className } = props, rest = __rest(props, ["route", "match", "exact", "strict", "className"]);
    const generate = useRoute();
    const location = useLocation();
    const activeClassName = (className === null || className === void 0 ? void 0 : className.split(/\s+/).shift()) + '--is-active';
    if (matches(generate, location.pathname, match)) {
        className += ' ' + activeClassName;
    }
    const to = generate.gen(route);
    return (React.createElement(NavLink, Object.assign({}, rest, { className: className, activeClassName: activeClassName, exact: exact, strict: strict, to: to, onClick: () => {
            if (props.onClick) {
                props.onClick();
            }
        } }), props.children));
}
/**
 * @function matches
 * @since 1.0.0
 */
export function matches(generator, location, target) {
    if (target == null) {
        return false;
    }
    if (typeof target == 'string') {
        target = [target];
    }
    return target.some((route) => {
        try {
            return matchPath(location, generator.get(route));
        }
        catch (e) {
            // A match list may name a route that is not defined: ignore it
            return false;
        }
    });
}
